import React from "react"
import parse from "html-react-parser"
import { contentParserOptions } from "./utils/contentParserOptions"

import "./content.module.scss"
import "../content-blocks/content-block.module.scss"

type ContentProps = {
  content: string
  styleListsAsGrid?: boolean
}

/*  TODO -- Check Links against Codex to make sure that we don't add dead internal links
additionally, we need to make sure external links work correctly.
*/

export const Content = ({ content, styleListsAsGrid }: ContentProps) => {
  const contentFormatted = content?.includes("iframe")
    ? content.replace(/&lt;/g, "<").replace(/&gt;/g, ">")
    : content

  const listsAsGrid = styleListsAsGrid ? " fr-content-list" : ""
  let maxListColums = ""

  if (styleListsAsGrid) {
    let itemCount = contentFormatted.split("<li>").length - 1
    if (itemCount && itemCount <= 4)
      maxListColums = "fr-content-list--max-" + itemCount
    // else if (itemCount > 4 && itemCount <= 6)
    //   //especial case item count low
    //   maxListColums = "fr-content-list--max-3" //3 column max balanced distribution
  }

  return (
    <div className={`fr-content-container ${listsAsGrid} ${maxListColums}`}>
      {parse(contentFormatted, contentParserOptions)}
    </div>
  )
}
